import React, { useMemo, useState } from "react";
import "./Catalog.css";

export default function Catalog() {
  const products = useMemo(
    () => [
      {
        id: 1,
        tag: "Accessories",
        name: "Wooden Wall Clock",
        price: 2900,
        oldPrice: null,
        img: "/bg1.png",
        type: "all",
      },
      {
        id: 2,
        tag: "Furniture",
        name: "Grey Vintage Chair",
        price: 4200,
        oldPrice: null,
        img: "/bg2.png",
        type: "featured",
      },
      {
        id: 3,
        tag: "Furniture",
        name: "Small Gray Table",
        price: 8700,
        oldPrice: null,
        img: "/lv1.png",
        type: "best",
      },
      {
        id: 4,
        tag: "Accessories",
        name: "Collection's Sconce",
        price: 18900,
        oldPrice: 20000,
        img: "/lv2.webp",
        type: "sale",
      },
      {
        id: 5,
        tag: "Accessories",
        name: "Black Vase",
        price: 2900,
        oldPrice: null,
        img: "/q2.webp",
        type: "featured",
      },
      {
        id: 6,
        tag: "Furniture",
        name: "Chest Of Drawers",
        price: 4200,
        oldPrice: null,
        img: "/q4.webp",
        type: "best",
      },
      {
        id: 7,
        tag: "Furniture",
        name: "White Table Lamp",
        price: 8700,
        oldPrice: null,
        img: "/tr1.avif",
        type: "all",
      },
      {
        id: 8,
        tag: "Accessories",
        name: "Minimal Circle Clock",
        price: 12000,
        oldPrice: 13000,
        img: "/tr2.avif",
        type: "sale",
      },

      // 8 autres (affichés après "Voir plus")
      {
        id: 9,
        tag: "Perfume",
        name: "Valentino Perfume",
        price: 3000,
        oldPrice: null,
        img: "/vt1.jpg",
        type: "featured",
      },
      {
        id: 10,
        tag: "Perfume",
        name: "Valentino Perfume",
        price: 7000,
        oldPrice: null,
        img: "/vt2.webp",
        type: "best",
      },
      {
        id: 11,
        tag: "Perfume",
        name: "Valentino Perfume",
        price: 3000,
        oldPrice: null,
        img: "/vt3.webp",
        type: "all",
      },
      {
        id: 12,
        tag: "Perfume",
        name: "Valentino Perfume",
        price: 3000,
        oldPrice: null,
        img: "/vt4.webp",
        type: "featured",
      },
      {
        id: 13,
        tag: "Hair Furniture",
        name: "Perruque courte",
        price: 15000,
        oldPrice: null,
        img: "/qt1.jpg",
        type: "best",
      },
      {
        id: 14,
        tag: "Hair Furniture",
        name: "Perruque courte",
        price: 21000,
        oldPrice: null,
        img: "/qt2.avif",
        type: "all",
      },
      {
        id: 15,
        tag: "Hair Furniture",
        name: "Perruque courte",
        price: 3900,
        oldPrice: 4900,
        img: "/qt3.webp",
        type: "sale",
      },
      {
        id: 16,
        tag: "Hair Furniture",
        name: "Perruque courte",
        price: 6600,
        oldPrice: null,
        img: "/qt4.avif",
        type: "best",
      },
    ],
    []
  );

  const tabs = [
    { key: "all", label: "ALL" },
    { key: "featured", label: "FEATURED" },
    { key: "best", label: "BEST SELLER" },
    { key: "sale", label: "SALES" },
  ];

  const [activeTab, setActiveTab] = useState("featured");
  const [visibleCount, setVisibleCount] = useState(8);

  const filtered = useMemo(() => {
    if (activeTab === "all") return products;
    return products.filter((p) => p.type === activeTab);
  }, [products, activeTab]);

  const shown = filtered.slice(0, visibleCount);
  const allowMore = visibleCount < filtered.length;

  const onChangeTab = (key) => {
    setActiveTab(key);
    setVisibleCount(8); // reset à 8 à chaque tab
  };

  const loadMore = () => setVisibleCount((c) => c + 8);

  return (
    <section className="catalogWrap-clts">
      <div className="catalogInner-clts">
        <h2 className="catalogTitle-clts">Attirez plus de clients avec votre catalogue de produits.</h2>

        <div className="tabs-clts" role="tablist" aria-label="Catalog tabs">
          {tabs.map((t) => (
            <button
              key={t.key}
              className={`tabBtn-clts ${activeTab === t.key ? "tabActive-clts" : ""}`}
              onClick={() => onChangeTab(t.key)}
              role="tab"
              aria-selected={activeTab === t.key}
              type="button"
            >
              {t.label}
            </button>
          ))}
        </div>

        <div className="grid-clts">
          {shown.map((p) => (
            <article key={p.id} className="card-clts">
              <div className="imgBox-clts">
                <img className="img-clts" src={p.img} alt={p.name} />
              </div>

              <div className="meta-clts">
                <div className="tag-clts">{p.tag}</div>
                <div className="name-clts">{p.name}</div>

                <div className="priceRow-clts">
                  <span className="price-clts">{p.price} FCFA</span>
                  {p.oldPrice ? (
                    <span className="oldPrice-clts">{p.oldPrice} FCFA</span>
                  ) : null}
                </div>
              </div>

             
            </article>
          ))}
        </div>

        <div className="bottom-clts">
          {allowMore ? (
            <button className="moreBtn-clts" onClick={loadMore} type="button">
              VOIR PLUS
            </button>
          ) : (
            <button className="moreBtn-clts moreDisabled-clts" type="button" disabled>
              PLUS D’ARTICLES
            </button>
          )}
        </div>
      </div>
    </section>
  );
}
